import type { NextPageSentinelState } from "./useChatHistory";

/** Mount the element the history hook observes for the next page, a fresh one for each list, only while the hook shows it. */
export function NextPageSentinel({
    sentinel,
}: {
    sentinel: NextPageSentinelState;
}) {
    return sentinel.show ? (
        <div key={sentinel.resetKey} ref={sentinel.ref} />
    ) : null;
}
